import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import ExpandingButton from "@/components/Buttons/ExpandingButton";
import BlogsContent from "@/components/Blog/BlogsContent";
import useBlogs from "@/hooks/useBlogs";
import { useState } from "react";
import localizePath from "@/functions/localizePath";
import useLocale from "@/hooks/useLocale";
import CustomSourceflowText from "@/components/Shared/CustomSourceflowText";

export default function CsrPageBlogFeed() {
  const locale = useLocale();
  const [blogs] = useState(useBlogs()?.slice(0, 3));

  return (
    <div className="container">
      <h2 className="text-3xl sm:text-[40px] xl:text-[50px]/[60px] max-w-[847px] pb-6">
        <CustomSourceFlowText
          title="Interview advice, insights and trends to help with your next role."
          path="dynamic1.csr.interview"
          locale={locale}
        />
      </h2>
      <ExpandingButton
        url={localizePath("/newsroom", locale)}
        color="white"
        bgColor="transparent"
        hoverBGColor="white"
        hoverColor="#1B0D34"
      >
        <CustomSourceflowText
          path="dynamic1.csr.learnmore"
          locale={locale}
          title={locale === "de" ? "Lerne mehr" : "Learn more"}
        />
      </ExpandingButton>
      <div className="md:mt-[-60px] pb-20 md:pb-[114px]">
        <BlogsContent
          blogData={blogs}
          style={{ arrow: "[&>path]:fill-white [&>path]:stroke-white" }}
          color="white"
        />
      </div>
    </div>
  );
}
